import styled from 'styled-components'

export const FilterInfo = styled.div`
    font-size: 12px;
    line-height: 14px;
    color: #7B8A8B;
    border-top: 1px solid #DCE4EC;
    padding: 9px 15px;
`
